module.exports = __webpack_public_path__ + "static/img/product4-4.adfd9d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product4-4.jpg
// module id = Nqwt
// module chunks = 0